import TemplateView from "../../TemplateView";
import {formatFML} from "../../util/UserNameFormat";
import messageResource from "../../messageResource"

export default class CopySettingsFromButton extends TemplateView {
    constructor() {
        super()

        this.state = {
            selectedUser: null,
        }

        this.onStatePropertyChanged('selectedUser', (user) => {
            const username = user ? formatFML(user.firstName, user.lastName, user.middleName) : "";
            const buttonTitle = user ?
                                messageResource.getMessage("user.add.js.copy_settings_from", [username]) :
                                messageResource.getMessage("user.add.js.copy_settings_from.empty");

            this.$userButton.text(buttonTitle);
        })
    }

    templateHtml() {
        return "<div class='buttonWrapper'>" +
               "    <div class='user ellipsis'/>" +
               "</div>"
    }

    afterRender() {
        this.$userButton = this.find('.user')
        this.renderInitialState()
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/CopySettingsFromButton.js